import React, { Component } from 'react';
import PasswordModal from 'components/modals/PasswordModal.js';
import TransactionsView from 'components/toolbar/TransactionsView.js';
import LoginModal from 'components/modals/LoginModal.js';
import {GUILD, USER, NONE} from 'constants/encryption-levels.js';
import ipfs from 'decentralized/Ipfs.js';
import accounts from 'accounts/Accounts.js';
import ContentKey from 'crypto/ContentKey.js';
import GuildsMenu from 'components/guilds/GuildsMenu.js';
import SampleSource from './SampleSource.js';
import UniversalNavigator from 'components/UniversalNavigator.js';
import { connect } from "react-redux";
import ConditionedComponent from 'components/ConditionedComponent.js';
import axios from 'axios';
import {getYoutubeTitle} from './getYoutubeTitle.js';
import AudioInputChooser from 'components/AudioInputChooser.js';
import ethereum from 'decentralized/ethereum.js';
import Discogs from 'discogs/Discogs.js';
import InternetNavigatorPane from './InternetNavigatorPane.js';
import NoteSequencePublisher from 'decentralized/chords/NoteSequencePublisher.js';
import { withRouter } from 'react-router-dom'
import {getEthereumNoteSequence} from 'tensorflow/Midifier.js';
import YoutubeSampler from './YoutubeSampler.js';
import YoutubeSearcher from './YoutubeSearcher.js';
import SampledSound from 'components/SampledSound.js';
import { Badge, Label, Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import SoundTagger from 'components/SoundTagger.js';
import EncryptedIpfs from 'decentralized/guilds/EncryptedIpfs.js';
import SoundsTags from 'search/SoundsTags.js';
import '../../Common.css';
import EthereumCache from 'decentralized/cache/EthereumCache.js';

const apiKey = "AIzaSyBrWhZMYJjBRGh9K3BDqj2bKT8sQ7K7JGc";

const VINYL = 'VINYL';
const YOUTUBE = 'YOUTUBE';

class Discover extends Component {
    constructor(props) {
        super(props);

        this.ethereumCache = new EthereumCache();
        ethereum.store = this.props.store;
        accounts.setStore(this.props.store);
        accounts.setEthereum(ethereum);
        accounts.checkLogin();
        ethereum.guilds.initGuilds();
        this.state = {
            videoId: 'j5L70BkuKlo',
            soundIds: [],
            sampleSource: YOUTUBE,
            selectedSoundIds: [],
            soundIdToHash: {},
            hashToSoundId: {},
            tagMode: false,
            soundIdToTags: {},
            hashToStyles: {},
            hashToSoundId: {},
            hashToYear: {},
            hashToCountry: {},
            hashToVideoId: {},
            hashToVideoTitle: {},
            hashToDiscogsId: {},
            styles: [],
            hashToCoverArt: {},
            year: undefined,
            country: undefined,
            syncedToEthereum: false,
            calculatingNoteSequences: false,
            noteSequencesCalculated: 0,
            stream: undefined,
            taggingSingleSound: false,
            soundIdToTag: undefined
        };

        this.onVideoIdChanged(this.state.videoId);

        this.discogs = new Discogs();
        this.soundsTags = new SoundsTags();

        ethereum.crypto.store = this.props.store;
        this.contentKey = new ContentKey();
        this.encryptedIpfs = new EncryptedIpfs(
            this.props.store,
            ethereum.guilds,
            ethereum.encryption,
            ethereum.crypto);
    }

    onCoverArtDownloaded(sampleHash, coverHash) {
        console.log('onCoverARtDownloaded');
        console.log(this.props.selectedRecord);
        let hashToCoverArt = { ... this.state.hashToCoverArt };
        hashToCoverArt[sampleHash] = coverHash;
        this.setState({
            hashToCoverArt: hashToCoverArt
        });
    }

    onChooseAudio(stream, deviceId) {
        console.log('deviceId chosen = ' + deviceId);
        this.setState({stream: stream, deviceId});
    }

    componentDidMount() {
       window.addEventListener("beforeunload", function (event) {
            event.returnValue = "Hellooww"
        })
    }

    async onSoundUploaded(soundId, ipfsHash) {
        this.state.syncedToEthereum = false;
        this.state.soundIdToHash[soundId] = ipfsHash;
        this.state.hashToSoundId[ipfsHash] = soundId;
        this.state.soundIds.push(soundId);
        this.state.soundIdToTags[soundId] = [];

        // keep track of discogs data for ipfs hash (to later save to ethereum)

        if (this.state.sampleSource === VINYL) {
            // it's vinyl so tag it as vinyl
            this.state.hashToVideoTitle[ipfsHash] = this.props.selectedRecord.title;
            this.state.hashToCountry[ipfsHash] = this.props.selectedRecord.country;
            this.state.hashToStyles[ipfsHash] = this.props.selectedRecord.style;
            this.state.hashToYear[ipfsHash] = this.props.selectedRecord.year;
            this.state.hashToDiscogsId[ipfsHash] = this.props.selectedRecord.id;
            this.soundsTags.tag(soundId, 'vinyl');
        } else {
            this.state.hashToVideoId[ipfsHash] = this.state.videoId;
            this.state.hashToVideoTitle[ipfsHash] = await this.getYoutubeTitle();
            this.state.hashToStyles[ipfsHash] = this.state.styles;
            this.state.hashToYear[ipfsHash] = this.state.year === undefined ? null : this.state.year;
            this.state.hashToCountry[ipfsHash] = this.state.country === undefined ? null : this.state.country;
        }
        this.setState(this.state);
    }

    onVideoIdChanged(videoId) {
        console.log("on videddd changed");
        this.state.videoId = videoId;
        this.getYoutubeTitle()
            .then(title =>
                  {
                      this.discogs.searchYoutubeTitle(title)
                          .then((results) =>this.loadDiscogsResults(results));
                  });
        this.setState(this.state);
    }

    loadDiscogsResults(results) {
        if (results == null || results === undefined) {
            this.setState({styles: [], country: undefined, year: undefined});
            return;
        }

        // get result with earliest year
        let result = results;
        if (results.length !== undefined ) {
            let minYear = Math.min.apply(Math, results.map(x => x.year));
            result = results.filter(x => x.year === minYear)[0];
        }
        this.setState({styles: result.style !== undefined ? result.style : [],
                       country: result.country,
                       year: result.year});
    }

    getYoutubeTitle() {
        return getYoutubeTitle(this.state.videoId);
    }

    onSampleSourceChange(type) {
        this.state.sampleSource = type === 'youtube' ?
            YOUTUBE : VINYL;
        this.setState(this.state);
    }

    loadVideo(result) {
        this.onVideoIdChanged(result.videoId);

    }

   selectSound(soundId) {                           
       var index = this.state.selectedSoundIds.indexOf(soundId);
       if (index > -1) {
           this.state.selectedSoundIds.splice(index, 1);
       } else {
           this.state.selectedSoundIds.push(soundId);
       }
       
       
       if (this.state.selectedSoundIds.length === 1 && index < 0) {
           window.dispatchEvent(new Event('sound_selected'));
       }
       
       this.setState({
           selectedSoundIds: this.state.selectedSoundIds,
           tagMode: true
       });
    }

    startTagging() {
        this.state.tagMode = true;
        this.setState(this.state);
    }

    backToSearch() {
        this.state.tagMode = false;
        this.setState(this.state);
    }

    onClickSequence(history) {
        var soundIds = this.state.selectedSoundIds.join(',');
        this.props.history.push('/sequencerSounds/' + soundIds);
    }

    onClickRandomVideo() {
        var self = this;
        let videos = this.ethereumCache.index.YOUTUBE.YOUTUBE;
        let randomVideo = videos[Math.floor(videos.length * Math.random())].dimension;

        this.loadVideo({videoId: randomVideo});
    }

    async syncToEthereum() {
        let promises:Promise<void>[] = [];
        let soundIds = [];
        let samples = [];
        for (let hash in this.state.hashToSoundId) {
            soundIds.push(this.state.hashToSoundId[hash]);
            let tags = this.state.soundIdToTags[this.state.hashToSoundId[hash]];
            let styles = this.state.hashToStyles[hash];
            if (styles.length > 4) {
                styles = styles.slice(0, 4);
            } 
            for (let i=styles.length; i < 4; i++) {
                styles.push('');
            }

            if (tags.length > 4) {
                tags = tags.slice(0, 4);
            } 
            for (let i=tags.length; i < 4; i++) {
                tags.push('');
            }

            let hashToSave = hash;
            if (this.props.selectedGuild) {
                let sound = await ipfs.getSound(hash) 
                // use the same content key to encrypt every sound uploaded here
                hashToSave = await this.encryptedIpfs.addSound(
                    sound, GUILD, this.props.selectedGuild.guildId, this.contentKey);
                console.log('hash to save = ');
                console.log(hashToSave);
            }

            samples.push({
                ipfsHash: hashToSave,
                title: this.state.hashToVideoTitle[hash],
                videoId: this.state.hashToVideoId[hash],
                tags: tags,
                styles: styles,
                country: this.state.hashToCountry[hash],
                year: this.state.hashToYear[hash],
                coverArt: this.state.hashToCoverArt[hash],
                discogsId: this.state.hashToDiscogsId[hash],
            });
        }
        let guildId = this.props.selectedGuild ? this.props.selectedGuild.guildId : 0;
        if (guildId !== 0) {
            ethereum.newEncryptedSamples(
                samples, guildId, this.contentKey);
        }  else {
            ethereum.newSamplesWithMetadata(
                samples, 0);
        }

        let finished = await Promise.all(promises);

        for (let id in this.state.soundIdToHash) {
            let hash = this.state.soundIdToHash[id];
            delete this.state.hashToVideoTitle[hash];
            delete this.state.hashToVideoId[hash];
            delete this.state.hashToVideoId[hash];
            delete this.state.hashToStyles[hash];
            delete this.state.hashToYear[hash];
            delete this.state.hashToCountry[hash];
            delete this.state.hashToSoundId[hash];
        }

        soundIds.forEach(id => delete this.state.soundIdToHash[id]);

        this.setState({
            soundIds: [],
            syncedToEthereum: true});
    }

    addTag(tag) {
        for (let i in this.state.selectedSoundIds) {
            let id = this.state.selectedSoundIds[i];
            if (id in this.state.soundIdToTags) {
                this.state.soundIdToTags[id].push(tag);
            } else {
                this.state.soundIdToTags[id] = [tag];
            }
        }
        
        this.setState(this.state);
    }
 
    deleteSound(id) {
        let hash = this.state.soundIdToHash[id];
        delete this.state.hashToVideoTitle[hash];
        delete this.state.hashToVideoId[hash];
        delete this.state.hashToVideoId[hash];
        delete this.state.hashToStyles[hash];
        delete this.state.hashToYear[hash];
        delete this.state.hashToCountry[hash];
        delete this.state.hashToSoundId[hash];
        delete this.state.soundIdToHash[id];
        let index = this.state.soundIds.indexOf(id);
        this.state.soundIds.splice(index, 1);
        this.setState(this.state);
    }

    deleteTag(soundId, tag) {
        let index = this.state.soundIdToTags[soundId].indexOf(tag);
        this.state.soundIdToTags[soundId].splice(index, 1);
        this.setState({soundIdToTags: this.state.soundIdToTags});
    }
   
    render() {
        return (
            <div className="discover-full-view">
              <PasswordModal crypto={ethereum.crypto} show={true}/>
              <LoginModal show={this.props.showLogin}/>
              <UniversalNavigator view="DISCOVER" store={this.props.store}/>
             <div className="discover-view">
             
              <div className="clear-fix"/>
             
              <div className="float-left">
              <div className="discover-toolbar">
                <GuildsMenu store={this.props.store}/>
                <ConditionedComponent condition={!this.state.syncedToEthereum && this.state.soundIds.length > 0}>
                  <div
                    onClick={() => this.syncToEthereum()}
                    className="pink-button common-button">
                    SAVE {this.state.soundIds.length} SOUNDS
                  </div>
                </ConditionedComponent>
                <TransactionsView/>
                <SampleSource
                  deviceId={this.state.deviceId}
                  onChooseAudio={(x, deviceId) => this.onChooseAudio(x, deviceId)}
                  onSampleSourceChange={(type) => this.onSampleSourceChange(type)}/>
              </div>
              <div className="youtube-pane">
                <YoutubeSampler
                  onCoverDownloaded={(sampleHash, coverHash) => this.onCoverArtDownloaded(sampleHash, coverHash)}
                  stream={this.state.stream}
                  styles={this.state.styles}
                  year={this.state.year}
                  country={this.state.country}
                  videoId={this.state.videoId}
                  onClickTag={() => this.startTagging()}
                  onSoundUploaded={(id, hash) => this.onSoundUploaded(id, hash)}
                  sampleSource={this.state.sampleSource}
                  onClickRandomVideo={() => this.onClickRandomVideo()}
                  playOutputRecording={this.state.sampleSource === VINYL}
                  />
                <ConditionedComponent condition={this.state.soundIds.length > 0}>
                  <div className="sampled-sounds-container">
                    {this.state.soundIds.map((soundId) =>
                      <SampledSound 
                        encryptedIpfs={this.encryptedIpfs}
                        key={soundId}
                        onDelete={() => this.deleteSound(soundId)}
                        tags={this.state.soundIdToTags[soundId]}
                        isSelected={this.state.selectedSoundIds.indexOf(soundId) > -1}
                        onClickThumbnail={() => this.selectSound(soundId)}
                        onDeleteTag={(tag) => this.deleteTag(soundId, tag)}
                        onClickTag={() => this.tagSound(soundId)}
                        coverArt={this.state.hashToCoverArt[soundId]}
                        videoId={this.state.hashToVideoId[this.state.soundIdToHash[soundId]]}
                        store={this.props.store}
                        title={this.state.hashToVideoTitle[this.state.soundIdToHash[soundId]]}
                        soundId={this.state.soundIdToHash[soundId]}/>
                        )}
                  </div>
                </ConditionedComponent>
              </div>
                </div>
              <div className="description-pane">
                {this.state.tagMode ?
                 <SoundTagger soundIdToHash={this.state.soundIdToHash} onClickBack={() => this.backToSearch()} onUpdateTags={(tag) => this.addTag(tag)} selectedSoundIds={this.state.selectedSoundIds}/> :
                 <InternetNavigatorPane store={this.props.store} videoId={this.state.videoId} onClickResult={(result) => this.loadVideo(result)}/>}
              </div>
                </div>
                </div>
        );
    }
}

                  
const mapStateToProps = state => {
    return {
        selectedRecord: state.discover.selectedRecord,
        selectedGuild: state.guilds.selectedGuild,
        showLogin: state.sequencer.showLogin,
    };
};

export default connect(mapStateToProps, null)(Discover);
